import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { CheckboxWithLabel } from "formik-material-ui";
import { Grid, Dialog, Button, SubmitButton, arrLanguages } from "../../../..";
import { makeStyles } from "@material-ui/styles";
import { FormControl, InputLabel, MenuItem } from "@material-ui/core";
import { Debug } from "../../../../Molecules/Forms/Debug";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap"
    },
    form: {
      display: "flex"
    },
    repeat: {
      margin: 0
    },
    mr30: {
      "margin-right": "30px"
    },
    actions: {
      display: "flex",
      "justify-content": "flex-end"
    },
    flex: {
      display: "flex"
    }
  };
});

var DialogCourseAddLanguage = function DialogCourseAddLanguage(props) {
  // console.log("props dialog", props);
  var initialValues = {};

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      languagesAvailable = _React$useState2[0],
      setLanguagesAvailable = _React$useState2[1];

  useEffect(function () {
    props.languages && setLanguagesAvailable(_toConsumableArray(arrLanguages.filter(function (language) {
      return language.value === "es" || language.value === "en" || language.value === "fr" || language.value === "pt" || language.value === "de" || language.value === "eu" || language.value === "it" || language.value === "ca";
    }).filter(function (language) {
      return !props.languages.includes(language.value);
    }).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    }).map(function (language) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 4
      }, /*#__PURE__*/React.createElement(Field, {
        name: language.value,
        Label: {
          label: language.label
        },
        component: CheckboxWithLabel
      }));
    })));
  }, [props.languages]);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: "Add languages",
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues // validationSchema={objectSchema}
    ,
    onSubmit: function onSubmit(values) {
      props.onSubmit(values);
      props.onClose();
    },
    render: function render(_ref) {
      var values = _ref.values;
      return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, languagesAvailable), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !values,
        component: SubmitButton,
        type: "submit"
      }, "Save")));
    }
  }));
};

export { DialogCourseAddLanguage };